import { Button, Modal, Spinner } from 'flowbite-react';
import { Img } from 'react-image';
import { RxCross2 } from 'react-icons/rx';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: () => void;
	isLoading: boolean;
}

const VideoResumeDisclaimerModal = ({ isOpen, onClose, onSubmit, isLoading }: Props) => {
	if (isOpen) {
		return (
			<Modal show={isOpen} size="lg" onClose={onClose}>
				<Modal.Body className="relative rounded-[8px] border border-solid border-[#555770] bg-[#1F2A37]">
					<div className="mt-[16px] flex justify-center">
						<Img
							loading="lazy"
							src="/assets/yellowInformationCircle.svg"
							alt="yellowInformationCircle"
							width="40"
							height="40"
						/>
					</div>

					<div className="mt-[20px] text-center text-2xl font-bold text-[#7777E7]">Disclaimer</div>
					<div className="mt-[16px] text-center text-sm font-normal text-[#FAFAFC]">
						Your video resume will play a vital role in your application process. Are you sure you want to submit?
					</div>

					<div className="mt-[36px] flex justify-end gap-[16px]">
						<Button color={'dark'} disabled={isLoading} className="!bg-[#555770] hover:!bg-[#374151]" onClick={onClose}>
							No
						</Button>
						<Button color="purplePlaced" onClick={onSubmit} disabled={isLoading}>
							{isLoading ? <Spinner /> : 'Yes'}
						</Button>
					</div>

					<RxCross2
						onClick={onClose}
						className="absolute right-[16px] top-[16px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
					/>
				</Modal.Body>
			</Modal>
		);
	} else return <div />;
};

export default VideoResumeDisclaimerModal;
